import { render, staticRenderFns } from "./fieldRequiredSettingList.vue?vue&type=template&id=bfac8b8e"
import script from "./fieldRequiredSettingList.vue?vue&type=script&lang=js"
export * from "./fieldRequiredSettingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports